import React from 'react'
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import MainLayout from '../layout/MainLayout';
import CommentList from '../components/CommentList';
import VoteTile from '../components/VoteTile';
import { Link } from 'react-router-dom';


function SenateSideBySide() {
    const { year, state } = useParams();

    const noWebsiteMessage = 'This candidate does not have a public website so we are unable to provide analysis.';
    const [senators, setSenators] = useState([]);
    const [votes, setVotes] = useState([0, 0]);

    const getSenators = async () => {
        axios
            .get("/api/v1/congress/senateRace/" + state + "/" + year)
            .then((result) => {
                let sens = result.data;
                setSenators(sens);
                sens.forEach((s, currentIdx) => {
                    axios.get("/api/v1/uservote/voted/30/" + s.id)
                        .then((result2) => {
                            if (result2.data) {
                                setAlreadyVoted(s.id);
                            }
                        })
                        .catch((err) => { });
                    axios.get("/api/v1/uservote/votes/30/" + s.id)
                        .then((result3) => {
                            setVotes(prevVotes =>
                                prevVotes.map((vote, index) =>
                                    index == currentIdx ? result3.data : vote
                                ));
                        })
                })


            })
            .catch((err) => console.log(err));
    };


    const [alreadyVoted, setAlreadyVoted] = useState();

    const [stateId, setStateId] = useState();
    const [stateMetadata, setStateMetadata] = useState({});
    const getStateMetadata = async () => {
        axios
            .get("/api/v1/states/" + state)
            .then((result) => {
                setStateMetadata(result.data);
                setStateId(result.data.id);
            })
            .catch((err) => console.log(err));
    };

    const handleVoteAction = (a) => {
        if (alreadyVoted == a) {
            setAlreadyVoted(0);
        }
        getSenators();
    }

    const formatText = (text, singleOrDouble) => {
        if (!text) return "";

        // Replace **bold** section numbers in EOs text
        let formatted = text.replace(/\*\*(.*?)\*\*\."(.*?)\."/g, "<strong><i>$1 - $2</i></strong><br/><br/>");

        //regular bold text
        formatted = formatted.replace(/\*\*(.*?)\*\*/g, "<strong><i>$1</i></strong><br/><br/>");

        // Add indentation for lines starting with *
        formatted = formatted.replace(
            /(^|\n)\*(.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$2</span>'
        );

        // Indent lines starting with numbers like 1., 2), 3:
        formatted = formatted.replace(
            /(^|\n)\d+[.):](.*)/g,
            '$1<span style="margin-left: 2em; display: block;">$&</span>'
        );

        //Web reference
        formatted = formatted.replace(
            /\(\[(.*)\]\((http.*)\)\)/g,
            '[<a href="$2">$1</a>]'
        )

        // Replace newlines with <br/>
        //formatted = formatted.replace(/\n\n/g, "\n");
        if (singleOrDouble === 's') {
            formatted = formatted.replace(/\n/g, "<br/>");
        } else {
            formatted = formatted.replace(/\n/g, "<br/><br/>");
        }



        return formatted;
    };

    const [showSummary, setShowSummary] = useState([true, true, true]);
    const toggleShowSummary = (targetIndex) => {
        setShowSummary(prevShowSummary =>
            prevShowSummary.map((show, index) =>
                index === targetIndex ? !show : show
            )
        )
    }

    const [showRed, setShowRed] = useState([false, false, false]);
    const toggleShowRed = (targetIndex) => {
        setShowRed(prevShowRed =>
            prevShowRed.map((show, index) =>
                index === targetIndex ? !show : show
            ))
    }

    const [showBlue, setShowBlue] = useState([false, false, false]);
    const toggleShowBlue = (targetIndex) => {
        setShowBlue(prevShowBlue =>
            prevShowBlue.map((show, index) =>
                index === targetIndex ? !show : show
            ))
    }

    useEffect(() => {
        getStateMetadata();
        getSenators();
    }, [], [])


    return (
        <MainLayout>
            <title>{"2026 " + stateMetadata.name + " Senate Race"}</title>
            <div>
                <div>
                    <Link to="/Senate2026.html">Back to List</Link>
                </div>
                <div className="content-image">
                    <center>
                        <h2><center>{stateMetadata.name}</center></h2>
                        <img src={"/graphics/flags/Flag_of_" + state.replace(' ', '_') + ".svg"} alt={state} />
                    </center>
                </div>
                <div className="column-container">
                    {senators.map((senator, index) => (
                        <div key={index} className="column">
                            <h2>{senator.name}    ({votes[index]} votes)</h2>
                            <h3>{senator.party}</h3>



                            {(alreadyVoted === senator.id || !alreadyVoted) &&
                                <VoteTile collectionGroupId={30} documentId={senator.id} documentSubject={""} sendValueBack={(e) => handleVoteAction(e)} />
                            }



                            <button className="accordion color-neutral" onClick={() => toggleShowSummary(index, !showSummary[index])}>
                                <img className={showSummary[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
                                <img className={!showSummary[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
                                <h4>Summary</h4>
                            </button>

                            <div className="accordion-panel" style={{ display: showSummary[index] ? "inherit" : "none" }}>
                                <div
                                    dangerouslySetInnerHTML={{ __html: formatText(senator.website ? senator.summary : noWebsiteMessage, 's') }}
                                />
                            </div>
                            <button className="accordion color-conservative" onClick={() => toggleShowRed(index, !showRed[index])}>
                                <img className={showRed[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
                                <img className={!showRed[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
                                <h4>Conservative Opinion</h4>
                            </button>
                            <div className="accordion-panel" style={{ display: showRed[index] ? "inherit" : "none" }}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: formatText(senator.website ? senator.conservativeOpinion : noWebsiteMessage, 's'),
                                    }}
                                />
                            </div>
                            <div>
                                <button className="accordion color-liberal" onClick={() => toggleShowBlue(index, !showBlue[index])}>
                                    <img className={showBlue[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-down.svg" alt="caret down" />
                                    <img className={!showBlue[index] ? "accordion-show" : "accordion-hide"} src="/graphics/icons/caret-right.svg" alt="caret right" />
                                    <h4>Liberal Opinion</h4>
                                </button>
                                <div className="accordion-panel" style={{ display: showBlue[index] ? "inherit" : "none" }}>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: formatText(senator.website ? senator.liberalOpinion : noWebsiteMessage, 's'),
                                        }}
                                    />
                                </div>

                            </div>
                        </div>
                    ))}

                </div>
                <br /><br />
                {stateId && (
                    <CommentList collectionGroupId={4} documentId={stateId} />
                )}

            </div>
        </MainLayout >

    )
}

export default SenateSideBySide
